export const previewText =
  'meta [Z] creates new values with and for your limited edition sneakers. Store, Trade and Flex sneakers like no other ';
